const snackbarDefaultMessages = {
  errorHeader: 'Something went wrong',
  errorText:
    'We could not complete your request. We are working on it. Please try again later.',
  imageUploadFetchError: 'Uploaded files are currently not available.',
  successHeader: 'Success',
};

export { snackbarDefaultMessages };
